"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JsonParseErrorCode;
(function (JsonParseErrorCode) {
    JsonParseErrorCode[JsonParseErrorCode["MISSING_PROPERTY"] = 0] = "MISSING_PROPERTY";
    JsonParseErrorCode[JsonParseErrorCode["INVALID_TYPE"] = 1] = "INVALID_TYPE";
    JsonParseErrorCode[JsonParseErrorCode["MISSING_ANNOTATION"] = 2] = "MISSING_ANNOTATION";
    JsonParseErrorCode[JsonParseErrorCode["INVALID_MODEL_CLASS"] = 3] = "INVALID_MODEL_CLASS";
    JsonParseErrorCode[JsonParseErrorCode["VALIDATION_FAILED"] = 4] = "VALIDATION_FAILED";
})(JsonParseErrorCode = exports.JsonParseErrorCode || (exports.JsonParseErrorCode = {}));
class JsonParseError {
    constructor(message, parseCode) {
        this.message = message;
        this.parseCode = parseCode;
        this.code = "bad_request";
    }
    toString() {
        return "JsonParseError: " + this.message;
    }
}
exports.JsonParseError = JsonParseError;
